"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _filter = require("ol/format/filter");

var _useWFSGetFeature = _interopRequireDefault(require("../../../../../hooks/wfs/useWFSGetFeature"));

var _usePrevious = _interopRequireDefault(require("../../../../../hooks/common/usePrevious"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WfsSearchByPropertyMenuBar = function WfsSearchByPropertyMenuBar(_ref) {
  var url = _ref.url,
      layer = _ref.layer,
      map = _ref.map,
      wfsOptions = _ref.wfsOptions,
      columnDefs = _ref.columnDefs,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "horizontal" : _ref$direction;

  var _useState = (0, _react.useState)(columnDefs),
      _useState2 = _slicedToArray(_useState, 2),
      internalColumnDefs = _useState2[0],
      setInternalColumnDefs = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      propertyName = _useState4[0],
      setPropertyName = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      propertyValue = _useState6[0],
      setPropertyValue = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      propertyValue2 = _useState8[0],
      setPropertyValue2 = _useState8[1];

  var _useState9 = (0, _react.useState)("equal_to"),
      _useState10 = _slicedToArray(_useState9, 2),
      filterName = _useState10[0],
      setFilterName = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hasNotfilter = _useState12[0],
      setHasNotFilter = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = _slicedToArray(_useState13, 2),
      matchCase = _useState14[0],
      setMatchCase = _useState14[1];

  var wfsGetFeature = (0, _useWFSGetFeature.default)();
  var previousColumnDef = (0, _usePrevious.default)(columnDefs);

  if (columnDefs !== previousColumnDef && columnDefs !== internalColumnDefs) {
    setInternalColumnDefs(columnDefs);

    if (columnDefs.length > 0) {
      setPropertyName(columnDefs[0].field);
    }
  }

  var onSearchClickHandler = (0, _react.useCallback)(function (event) {
    if (!layer) return;
    layer.getSource().clear();
    var filter = null;

    switch (filterName) {
      case 'equal_to':
        filter = (0, _filter.equalTo)(propertyName, propertyValue, matchCase);
        break;

      case 'not_equal_to':
        filter = (0, _filter.notEqualTo)(propertyName, propertyValue, matchCase);
        break;

      case 'like':
        filter = (0, _filter.like)(propertyName, propertyValue, '*', '.', '!', matchCase);
        break;

      case 'is_null':
        filter = (0, _filter.isNull)(propertyName);
        break;

      case 'greater_than':
        filter = (0, _filter.greaterThan)(propertyName, propertyValue);
        break;

      case 'greater_than_or_equal_to':
        filter = (0, _filter.greaterThanOrEqualTo)(propertyName, propertyValue);
        break;

      case 'less_than':
        filter = (0, _filter.lessThan)(propertyName, propertyValue);
        break;

      case 'less_than_or_equal_to':
        filter = (0, _filter.lessThanOrEqualTo)(propertyName, propertyValue);
        break;

      case 'between':
        filter = (0, _filter.between)(propertyName, propertyValue, propertyValue2);
        break;

      default:
        filter = null;
    }

    if (hasNotfilter) {
      filter = (0, _filter.not)(filter);
    }

    var wfsFilteredOptions = _objectSpread(_objectSpread({}, wfsOptions), {}, {
      filter: filter
    });

    wfsGetFeature.sendRequest(url, map, layer, wfsFilteredOptions);
  }, [wfsGetFeature, layer, url, wfsOptions, filterName, propertyName, propertyValue, matchCase, hasNotfilter, map, propertyValue2]);
  var onFilterNameChangeHandler = (0, _react.useCallback)(function (value) {
    setFilterName(value);
  }, []);
  var onHasNotFilterChangeHandler = (0, _react.useCallback)(function (value) {
    setHasNotFilter(value);
  }, []);
  var onMatchCaseChangeHandler = (0, _react.useCallback)(function (value) {
    setMatchCase(value);
  }, []);
  var onPropertyNameChangeHandler = (0, _react.useCallback)(function (value) {
    setPropertyName(value);
  }, []);
  var onPropertyValueChangeHandler = (0, _react.useCallback)(function (value) {
    setPropertyValue(value.target.value);
  }, []);
  var onPropertyValue2ChangeHandler = (0, _react.useCallback)(function (value) {
    setPropertyValue2(value.target.value);
  }, []);
  var matchCaseControl = null;

  if (filterName === 'equal_to' || filterName === 'not_equal_to' || filterName === 'like') {
    matchCaseControl = /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Switch, {
      checkedChildren: "Match Case",
      unCheckedChildren: "NO Match Case",
      defaultChecked: matchCase,
      onChange: onMatchCaseChangeHandler
    });
  }

  var betweenControl = null;

  if (filterName === 'between') {
    betweenControl = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Space, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "AND"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {
        placeholder: "Property Value",
        onChange: onPropertyValue2ChangeHandler,
        onPressEnter: onSearchClickHandler
      })]
    });
  }

  return (
    /*#__PURE__*/
    // <div style={{display:"flex",  flexDirection:'column', columnGap: 5, rowGap:5}}>
    (0, _jsxRuntime.jsxs)(_antd.Space, {
      direction: direction,
      style: {
        display: 'flex',
        margin: 5
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
        type: "primary",
        loading: wfsGetFeature.isLoading,
        onClick: onSearchClickHandler,
        children: "Search"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select, {
        style: {
          width: 200
        },
        value: propertyName,
        onChange: onPropertyNameChangeHandler,
        children: columnDefs.map(function (column, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
            value: column.field,
            children: column.field
          }, index);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Switch, {
        checkedChildren: "Not",
        defaultChecked: hasNotfilter,
        onChange: onHasNotFilterChangeHandler
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Select, {
        defaultValue: filterName,
        style: {
          width: 200
        },
        onChange: onFilterNameChangeHandler,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "equal_to",
          children: "Equal To"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "not_equal_to",
          children: "Not Equal To"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "like",
          children: "Like"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "is_null",
          children: "Is Null"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "greater_than",
          children: "Greater Than"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "greater_than_or_equal_to",
          children: "Greater Than or Equal To"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "less_than",
          children: "Less Than"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "less_than_or_equal_to",
          children: "Less Than or Equal To"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
          value: "between",
          children: "Between"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {
        placeholder: "Property Value",
        onChange: onPropertyValueChangeHandler,
        onPressEnter: onSearchClickHandler
      }), betweenControl, matchCaseControl]
    }) // </div>

  );
};

var _default = WfsSearchByPropertyMenuBar;
exports.default = _default;